export default {
  mock: {
    auth: false,
    assets: false,
    coins: false,
    orders: true,
    rates: true,
    ui: true,
    moderation: true,
  },
  services: {

    // Route auth through the app worker in production so stubbed API responses stay same-origin.
    auth: process.env.NODE_ENV === 'production' ? 'https://app.economix.ai' : 'http://localhost:3006',
    // rating: 'https://app.economix.ai',
    rating: process.env.NODE_ENV === 'production' ? 'https://app.economix.ai' : 'http://localhost:3008',
    // order: 'https://app.economix.ai',
    order: process.env.NODE_ENV === 'production' ? 'https://orders.economix.ai' : 'http://localhost:3013',
    mobile: process.env.NODE_ENV === 'production' ? 'https://mobile.economix.ai' : 'http://localhost:3005',
  }
}



// WEBPACK FOOTER //
// ./src/config.js